import { gql } from '@apollo/client'

export const UPDATE_USER_PHOTO = gql`
  mutation UpdateUserPhoto($photoURL: String!, $isPresetAvatar: Boolean) {
    updateUserPhoto(input: { photoURL: $photoURL, isPresetAvatar: $isPresetAvatar }) {
      id
    }
  }
`

export const REMOVE_USER_PHOTO = gql`
  mutation {
    removeUserPhoto {
      id
    }
  }
`
